import axios from "axios";

export default {
  data() {
    return {
      isLoading: false,
      equipments: []
    };
  },
  methods: {
    async getEquipments(searchQuery) {
      if (!searchQuery || searchQuery.length < 3 || this.isLoading) {
        return [];
      }

      this.isLoading = true;

      const equipments = await axios
        .post("/local/ajax/route/crm/equpment/list/", {
          eq_name: searchQuery
        })
        .then(res => res.data.eq_name_list || []);

      this.isLoading = false;

      return equipments;
    },
    async onUpdateEquipmentSearchInput(value) {
      this.equipments = await this.getEquipments(value);
    }
  }
};
